import { useState, useEffect } from "react";


export default function BetaGate({ children }) {
  const [hasAccess, setHasAccess] = useState(false);
  const [input, setInput] = useState("");
  const PASSWORD = process.env.REACT_APP_BETA_PASSWORD || 'whatayathink32765';



  useEffect(() => {
    const unlocked = localStorage.getItem("beta_access") === "true";
    setHasAccess(unlocked);
  }, []);

  const handleSubmit = () => {
    if (input === PASSWORD) {
      localStorage.setItem("beta_access", "true");
      setHasAccess(true);
    } else {
      alert("Incorrect password. Try again.");
    }
  };

  if (hasAccess) return children;

  return (
    <div style={{
      display: "grid",
      placeItems: "center",
      minHeight: "100vh",
      backgroundColor: "#111",
      color: "#fff",
      fontFamily: "sans-serif",
    }}>
      <div style={{ padding: 20, maxWidth: 400, textAlign: "center" }}>
        <h2>🔒 Beta Access</h2>
        <p>Enter the password to view the site:</p>
        <input
          type="password"
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="Beta password"
          style={{ padding: 8, width: "100%", marginBottom: 12 }}
        />
        <button onClick={handleSubmit} style={{ padding: 8, width: "100%" }}>
          Enter
        </button>
      </div>
    </div>
  );
}
